type WebsocketResponse = {
    action: string;
    [key: string]: unknown;
};

export function sendAndWaitForResponse<T = unknown>(
    socket: WebSocket,
    payload: object,
    expectedAction: string,
    timeout = 5000,
): Promise<T> {
    return new Promise((resolve, reject) => {
        let timer: ReturnType<typeof setTimeout>;
        const handleMessage = (event: MessageEvent) => {
            try {
                const data: WebsocketResponse = JSON.parse(event.data);

                if (data) {
                    socket.removeEventListener('message', handleMessage);
                    clearTimeout(timer);
                    resolve(data as T);
                }
            } catch (e) {
                console.error('[WS] Error parsing message', e);
            }
        };

        timer = setTimeout(() => {
            socket.removeEventListener('message', handleMessage);
            reject(new Error(`Timeout while waiting for "${expectedAction}" response.`));
        }, timeout);

        socket.addEventListener('message', handleMessage);
        socket.send(JSON.stringify(payload));
    });
}
